import React from "react";
import { FiCloud, FiKey, FiShield } from "react-icons/fi";
import swanMark from "../../../../vendor/swan.png";
import { ThemeProvider } from "../../../../components/lib/theme-provider";
import { ThemeToggle } from "../../../../components/v2components/ThemeToggle";
import "./AuthenticationPage.css";
import "./AuthenticationBrand.css";

const FOOTER_LINKS = [
  { label: "Terms and Conditions", href: "https://app.termly.io/document/terms-of-service/d8371bb3-6629-4b1e-95c5-3cf56e89c51c" },
  { label: "About", href: "https://www.whiteswansecurity.com/about/" },
  { label: "Contact", href: "https://www.whiteswansecurity.com/contact/" },
];

const BRAND_POINTS = [
  {
    icon: FiShield,
    title: "Just-in-time privileged access",
    text: "Grant access only when it is needed and remove it automatically.",
  },
  {
    icon: FiCloud,
    title: "Every identity, one console",
    text: "Endpoints, Active Directory, AWS, Azure and GCP side by side.",
  },
  {
    icon: FiKey,
    title: "Passwordless by design",
    text: "Sign in with passkeys, one-time codes or your company SSO.",
  },
];

const FooterLinks = () => (
  <nav>
    {FOOTER_LINKS.map((link) => (
      <a key={link.label} href={link.href} target="_blank" rel="noopener noreferrer">
        {link.label}
      </a>
    ))}
  </nav>
);

const BrandLogo = ({ tone }) => (
  <div className="auth-logo" data-tone={tone}>
    <img src={swanMark} alt="" aria-hidden="true" />
    <div className="auth-logo-text">
      <strong>WHITESWAN</strong>
      <span>Identity Security</span>
    </div>
  </div>
);

const AuthenticationPage = ({ children }) => (
  <ThemeProvider defaultTheme="system" storageKey="device-management-theme" persistTheme={false}>
    <div className="auth-shell">
      <aside className="auth-brand" aria-label="Whiteswan Identity Security">
        <div className="auth-brand-grid" />
        <div className="auth-brand-center">
          <div className="auth-brand-stack">
            <BrandLogo tone="light" />
            <div className="auth-brand-body">
              <div className="auth-brand-eyebrow">
                <span />
                Identity security platform
              </div>
              <h2>Zero standing privilege for every identity you run.</h2>
              <p>
                Whiteswan secures human and non-human identities across your endpoints and clouds, so access exists only
                while it is needed.
              </p>
              <ul className="auth-brand-points">
                {BRAND_POINTS.map(({ icon: Icon, title, text }) => (
                  <li key={title}>
                    <span>
                      <Icon aria-hidden="true" />
                    </span>
                    <div>
                      <strong>{title}</strong>
                      <small>{text}</small>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="auth-brand-footer">
          <span>© 2026 Whiteswan Security. All rights reserved.</span>
          <FooterLinks />
        </div>
      </aside>

      <div className="auth-main">
        <header className="auth-mobile-header">
          <BrandLogo tone="brand" />
        </header>
        <main className="auth-content">
          <div className="auth-card-frame">
            <div className="auth-card-toggle">
              <ThemeToggle />
            </div>
            {children}
          </div>
        </main>
        <footer className="auth-mobile-footer">
          <span>© 2026 Whiteswan Security. All rights reserved.</span>
          <FooterLinks />
        </footer>
      </div>
    </div>
  </ThemeProvider>
);

export default AuthenticationPage;
